import axios from "axios";
import baseUrl from "../config/baseURL";
import { getAuthToken } from "../services/auth";

export const getQuotes = async (organization_id: any, customer_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = "Bearer " + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/leads/${customer_id}/quotes`;
        const response = await axios.get(endpoint, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error("Data retrieval failed:", response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error("An unexpected error occurred:", error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};

export const getQuote = async (organization_id: any, customer_id: any, quote_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = "Bearer " + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/leads/${customer_id}/quotes/${quote_id}`;
        const response = await axios.get(endpoint, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error("Data retrieval failed:", response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error("An unexpected error occurred:", error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};

export const createQuote = async (
  organization_id: string | number,
  lead_id: string | number,
  reference_number: string = "",
  notes: string = "",
  valid_until: string | null = null,
  created_by: number | null = null
) => {
  try {
    const token = await getAuthToken();
    if (!token) {
      return { success: false, data: "error: Token does not exist" };
    }

    const headers = { Authorization: `Bearer ${token.data}` };

    // build request body directly from params
    const body = {
      reference_number,
      status: "draft", // always draft on creation
      notes,
      valid_until,
      lead_id: lead_id,
      created_by,
    };

    const endpoint = `${baseUrl}/core/organizations/${organization_id}/leads/${lead_id}/quotes/`;
    const response = await axios.post(endpoint, body, { headers });
    console.log('create quote response', response);

    if (response.status >= 200 && response.status < 300) {
      return { success: true, data: response.data };
    } else {
      console.error("Quote creation failed:", response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error("An unexpected error occurred:", error?.response?.data || error);
    return { success: false, data: error?.response?.data || error };
  }
};



// export const createQuote = async (organization_id: any, customer_id: any, notes:any, payload: any) => {
//   let token = await getAuthToken();
//   {
//     "reference_number": "",
//     "status": 'draft',
//     "notes": "",
//     "valid_until": null,
//     "customer": null,
//     "created_by": null
// }
//   try {
//     if (token) {
//       let header_token = "Bearer " + token.data;
//       const headers = { Authorization: header_token };

//       try {
//         const endpoint = `${baseUrl}/core/organizations/${organization_id}/customers/${customer_id}/quotes`;
//         const response = await axios.post(endpoint, payload, { headers });

//         if (response.status >= 200 && response.status <= 400) {
//           return { success: true, data: response?.data };
//         } else {
//           console.error("Quote creation failed:", response.data);
//           return { success: false, data: response?.data };
//         }
//       } catch (error) {
//         console.error("An unexpected error occurred:", error);
//         return { success: false, data: error };
//       }
//     } else {
//       return { success: false, data: "error: Token does not exist" };
//     }
//   } catch (error) {
//     console.error("Unexpected error:", error);
//     return { success: false, data: undefined };
//   }
// };

export const updateQuote = async (organization_id: any, customer_id: any, quote_id: any, payload: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = "Bearer " + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/leads/${customer_id}/quotes/${quote_id}`;
        const response = await axios.put(endpoint, payload, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error("Quote update failed:", response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error("An unexpected error occurred:", error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};

export const deleteQuote = async (organization_id: any, customer_id: any, quote_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = "Bearer " + token.data;
      const headers = { Authorization: header_token };

      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/leads/${customer_id}/quotes/${quote_id}/`;
        const response = await axios.delete(endpoint, { headers });

        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error("Quote deletion failed:", response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error("An unexpected error occurred:", error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: "error: Token does not exist" };
    }
  } catch (error) {
    console.error("Unexpected error:", error);
    return { success: false, data: undefined };
  }
};